import styled from "styled-components";

const DescriptionSpan = styled.span`
  display: block;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 800;
  color: #000;
`;
export default DescriptionSpan;
